<template>
    <div class="secondStep">
      <div class="matching_box">
        <div class="btn">
          <label>从第几行开始获取：</label>
          <el-input  v-model="obj.index"></el-input>
          <a href="javascript:;" class="change-btn" @click="changeBtn">确定</a>
        </div>
        <div class="hint_msg">
          <p>红框内的表头在第一行，所以输入框输入1就可以了</p>
          <img src="@/assets/binding_case.png">
        </div>
      </div>
      <div class="select_box">
        <div class="title">设置查询条件</div>
        <dl>
          <dt><span class="column">列数</span><span class="name">名称</span></dt>
          <dd v-for="(item,index) of list" :key="index" v-show="!item.isDel">
            <i class="el-icon-delete" @click="deleteBtn(item)"></i>
            <div class="left_box">
              <span class="column">{{item.num+1}}</span>
              <span class="name"><i style="color:red" v-if="false">*</i>{{item.name}}</span>
            </div>
            <el-checkbox v-model="item.isSele"></el-checkbox>
            <div class="right_box" v-if="item.isSele">
              提示语：
              <el-input :placeholder="'请输入'+item.name" v-model="input" :disabled="true"></el-input>
            </div>
          </dd>
        </dl>
      </div>
      <div class="btn_box">
        <a href="javascript:;" class="border-btn" @click="setActive(1)">上一步</a>
        <a href="javascript:;" class="change-btn" @click="createBtn">生成成绩单</a>
      </div>
    </div>
</template>
<script>
import { getNotLoginHeader,notLoginimport } from '@/api/common_api'
export default {
  data(){
    return{
      name:'',
      option:[]
    }
  },
  props:{
    obj:{
      type:Object
    },
    list:{
      type:Array
    }
  },
  created(){
    this.getHeader()
  },
  methods:{
    getHeader(){
      let obj = JSON.parse(JSON.stringify(this.obj))
      obj.index--
      getNotLoginHeader(obj).then(res=>{
        if(res.s==1){
          if(!this.list.length){
            res.d.list.map(item=>{
              item.isSele = !!item.iskey
              item.isDel = false
              return item
            })
            this.list = res.d.list
          }else{
            res.d.list.map((item,index)=>{
              this.list[index].id = item.id
              return item
            })
          }
          this.obj.subjectName = res.d.subjectName
          this.obj.queryName = res.d.queryName
          this.obj.customName = res.d.customName
          this.$parent.obj = this.obj
        }else{
          this.$message.error(res.d)
        }
      })
    },
    deleteBtn(item){
      this.$confirm('确定不再读取该列数据?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        item.isDel = true
      }).catch(() => {
                 
      });
    },
    //生成临时表
    createBtn(){
      let obj = JSON.parse(JSON.stringify(this.obj))
      let list = JSON.parse(JSON.stringify(this.list))
      let num=0,ary = []
      obj.index--
      list = list.map((ele,index)=>{
        obj[`head[${index}].num`] = ele.num
        obj[`head[${index}].id`] = ele.id
        obj[`head[${index}].name`] = ele.name
        obj[`head[${index}].isKey`] = ele.isSele?1:0
        if(ele.isDel){
          ary.push(ele.num)
        }
        if(ele.isSele){
          num++
        }
        return ele
      })
      if(num<1){
        this.$message.error('请至少选择一个查询条件')
        return false
      }
      obj.fileName = obj.origName
      obj.num = ary.join(',')
      delete obj.origName
      notLoginimport(obj).then(res=>{
        if(res.s==1){
          this.$parent.list2 = this.list
          this.$parent.transcriptId = res.d.transcriptId
          this.setActive(3)
        }else{
          this.$message.error(res.d)
        }
      })
    },
    //改变列数
    changeBtn(){
      this.$parent.list = []
      this.list=[]
      this.getHeader()
    },
    setActive(val){
      this.$parent.setActive(val)
    }
  }
}
</script>
<style lang="less" scoped>
.secondStep{
  font-size: 14Px;
  margin-top: 43Px;
  .matching_box{
    display: flex;
    justify-content: space-between;
    .btn{
      margin-top: 19Px;
      margin-left: 29Px;
      /deep/ .el-input{
        width: 80Px;
        margin-right: 14Px;
      }
    }
    .hint_msg{
      text-align: center;
      margin-right: 16Px;
      color: #666;
      line-height: 24Px;
    }
  }
  .select_box{
    width: 560Px;
    margin: 48Px auto 60Px;
    .title{
      font-size: 15Px;
      text-align: center;
      margin-bottom: 23Px;
    }
    span{
      display: inline-block;
    }
    dt{
      padding-left: 18Px;
      line-height: 30Px;
      .column{
        width: 95Px;
      }
      .name{
        width: 88Px;
      }
      .type{
        width: 201Px;
        text-align: center;
        margin-left: 74Px;
      }
    }
    dd{
      display: flex;
      margin-bottom: 8Px;
      /deep/ .el-icon-delete{
        line-height: 32Px;
        margin-right: 10Px;
        cursor: pointer;
        &:hover{
          color: #1890FF;
        }
      }
      .left_box{
        width: 201Px;
        height: 32Px;
        line-height: 30Px;
        box-sizing: border-box;
        border: 1px solid #979797;
        padding-left: 26Px;
        .column{
          width: 72Px;
          color: #333;
        }
      }
      .line{
        display: inline-block;
        width: 58Px;
        height: 5Px;
        background: #D8D8D8;
        vertical-align: middle;
        margin: 13Px 7Px 0 9Px;
      }
      .right_box{
        width: 280Px;
        /deep/ .el-input{
          width: 200Px;
        }
        /deep/ .el-input__inner{
          height: 32Px;
          line-height: 32Px;
        }
        /deep/ .el-input__icon{
          line-height: 32Px;
        }
      }

      /deep/ .el-checkbox{
        margin: 0 15Px;
        box-sizing: border-box;
        padding-top: 9Px;
      }
      
    }
  }
  .btn_box{
    text-align: center;
    .change-btn{
      margin-left: 34Px;
    }
  }
}
</style>